import { render, staticRenderFns } from "./scoreDetail.vue?vue&type=template&id=ea54082e&scoped=true&"
import script from "./scoreDetail.vue?vue&type=script&lang=js&"
export * from "./scoreDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea54082e",
  null
  
)

export default component.exports